import { useEffect } from "react";

const InputField2 = ({
  type,
  red,
  name,
  register,
  disabled,
  defaultValue,
  errors,
  label,
  labelWidth,
  autoComplete,
  valueAsNumber,
}) => {
  useEffect(() => {}, [defaultValue]);
  return (
    <>
      <div className="input-container py-1">
        <div className="flex gap-4 justify-center items-center">
          <label
            htmlFor={name}
            className={
              "block text-text-1/90 font-medium text-nowrap " + labelWidth
            }
          >
            {label}
          </label>
          <input
            disabled={disabled}
            className={`w-full px-3 py-2 border text-base r rounded-md bg-content ${
              red ? " border-red-500 " : " border-bkg2 "
            } focus:outline-none ${
              red ? " focus:border-red-400 " : " focus:border-primary "
            } text-text-1/75 disabled:bg-bkg2/45 `}
            type={type}
            min={0}
            // placeholder={placeholder}
            autoComplete={autoComplete ? autoComplete : ""}
            {...register(name, { valueAsNumber })}
            defaultValue={defaultValue ? defaultValue : ""}
            step={type === "number" ? 0.01 : ""}
          />
          {/* {errors && <p className="input-error-text">{errors.message}</p>} */}
        </div>
        {
          <p className="text-red-400 text-xs text-wrap w-fit">
            {errors && errors.message} <span className="invisible">Sample</span>
          </p>
        }
      </div>
    </>
  );
};

export default InputField2;
